import { defineMessages } from 'react-intl'

export const commonMessages = defineMessages({
  unknowError: {
    defaultMessage: 'Something went wrong. Contact Support.',
    description: 'unknow error message',
  },
})
